import * as queryString from 'query-string'
import { matchRoutes } from 'react-router-config'
import { match as IMatch } from 'react-router-dom'
import { Site } from '../../common/constants/siteList'
import { IExtendedRouteConfig } from '../../common/routes/types'
import { getSearchLocationParams } from '../../common/utils/location'
import { sanitizeQueryParams } from '../../common/utils/location/sanitize'
import { ICommonLocation, IQuery } from '../../common/utils/location/types'

const gaSimplifiedSearchUrl = (
  routes: IExtendedRouteConfig[],
  location: ICommonLocation,
  baseUrl: string,
  currentSite: Site,
  experiments: any
): string | undefined => {
  let path
  matchRoutes(routes, location.pathname).forEach(
    ({
      route,
      match
    }: {
      route: IExtendedRouteConfig
      match: IMatch<IQuery>
    }) => {
      if (match.isExact && route.isSearchRoute) {
        const locationParams = getSearchLocationParams({
          location,
          routeMatch: match,
          currentSite,
          experiments
        })
        path = `${baseUrl}/search?${queryString.stringify(
          sanitizeQueryParams(locationParams)
        )}`
      }
    }
  )
  return path
}

export default gaSimplifiedSearchUrl
